import { TableCell } from '@mui/material';

const BSTableHeaderCell = ({ children, hidden, ...props }) => {
  return hidden ? null : (
    <TableCell
      sx={{
        color: 'text.secondary',
        fontWeight: 600,
        fontSize: 12,
        letterSpacing: 0.4,
        textTransform: 'uppercase',
        borderBottom: '1px solid',
        borderColor: 'divider',
        py: 1.25
      }}
      {...props}>
      {children}
    </TableCell>
  );
};

export default BSTableHeaderCell;
